import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items = [], testId = "breadcrumbs" }) => (
    <nav
        data-testid={testId}
        aria-label="Breadcrumb"
        className="text-[11px] tracking-[0.2em] uppercase opacity-70 flex flex-wrap items-center gap-2 mb-8"
    >
        {items.map((item, idx) => {
            const isLast = idx === items.length - 1;
            return (
                <span key={item.href} className="flex items-center gap-2">
                    {isLast ? (
                        <span className="opacity-70">{item.label}</span>
                    ) : (
                        <Link
                            to={item.href}
                            className="hover:opacity-100 transition-opacity"
                        >
                            {item.label}
                        </Link>
                    )}
                    {!isLast ? (
                        <ChevronRight
                            size={12}
                            strokeWidth={1.5}
                            className="opacity-50"
                        />
                    ) : null}
                </span>
            );
        })}
    </nav>
);
